module.exports = __webpack_public_path__ + "img/q2.96cf676b.gif";